/* eslint-disable no-unused-vars */
export enum Themes {
  DEFAULT = 'default',
  REFINANCE = 'refinance',
  BUYING = 'buying',
  INVESTMENT = 'investment',
}
